<template>
	<div class="fake-search-box flex-between">
		<img src="@/assets/icon/icon_search_gray.png" style="margin: 0 0.25rem 0 0.9375rem;font-size: 1.25rem;height: 0.875rem;width: 0.9375rem;"/>
		<input ref="innerInput" :placeholder="placeholder" v-model="value" />
		<div v-if="showClearIcon&&value!=''&&value!=null&&value!=undefined" style="line-height: 2rem;border-radius: 0 2rem 2rem 0;padding-right: 0.3125rem;" @click="clearValue">
			<img src="@/assets/icon/ibtn_clear_edit_text.png" style="display: block;font-size: 1.25rem;height: 0.9375rem;width: 0.9375rem;margin-right: 0.9375rem;"/>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				value: ""
			}
		},
		props: {
			placeholder: {
				type: String,
				default: "请输入"
			},
			showClearIcon: {
				type: Boolean,
				default: true,
			}
		},
		watch: {
			value(newValue, oldValue) {
				this.search(newValue);
			}
		},
		methods: {
			setValue(kw) {
				this.$set(this, 'value', kw);
			},
			clearValue() {
				this.$emit("clear");
				this.$set(this, 'value', '');
			},
			//为了防止频繁请求接口，做了一个500毫秒的延时处理
			search: _.debounce(function(kw) {
				this.$emit("search", kw);
			}, 500),
			focus() {
				this.$refs.innerInput.focus();
			},
		},
	}
</script>

<style lang="less" scoped>
	.fake-search-box {
		border-radius: 28px;
		width: 100%;
		height: 2rem;
		background-color: #F8F8F8;
		color: rgba(0, 0, 0, 0.6);

		input {
			font-size: 0.875rem;
			width: 100%;
			line-height: 20px;
			border: none;
			background-color: transparent;
			text-align: left !important;
		}
	}
</style>
